import $ from 'jquery'
/**
 * @module
 * @api
 */

/**
 * UI tool class
 *
 * @param {string} position
 * @constructor
 */
export default function Button(position) {
  this.$label = $('<span></span>').addClass('hidden-xs')
  this.$icon = $('<i></i>')
  this.$element = this.createButtonElement(position)
}

/**
 * Create button element based on position. Different button
 * @param {string} position
 * @return {element} button as jQuery element
 */
Button.prototype.createButtonElement = function(position) {
  var $button

  if (position.indexOf('top') > -1) {
    $button = this.createNavbarNorthButton()
  } else if (position.indexOf('bottom') > -1) {
    $button = this.createNavbarSouthButton()
  }

  return $button
}

/**
 * Create button for the north navbar
 * @return {element} button as jQuery element
 */
Button.prototype.createNavbarSouthButton = function() {
  var $button = $('<button></button>')
    .addClass('link-navbar')
    .attr('type', 'button')

  this.$icon.appendTo($button)

  this.$label.appendTo($button)

  return $button
}

/**
 * Create button for the south navbar
 * @return {element} button as jQuery list element
 */
Button.prototype.createNavbarNorthButton = function() {
  var $button = $('<li></li>')

  var $link = $('<a></a>').appendTo($button)

  this.$icon.appendTo($link)
  this.$label.appendTo($link)

  return $button
}

/**
 * Sets or gets button text
 * @param {string} text
 * @memberof! module:api/Button#
 * @api
 * @return {string} text
 */
Button.prototype.text = function(text) {
  if (text !== undefined) {
    this.$label.text(text)
  }

  return this.$label.text()
}

/**
 * Sets button icon
 * @param {string} icon A Font Awsome CSS class name eg. "cogs" or "fa-arrows-alt".
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.icon = function(icon) {
  this.$icon
    .removeClass()
    .addClass('fa')
    .addClass(icon)
}

/**
 * Add button event listener
 * @param {string} event jQuery event name
 * @param {function} callback
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.on = function(event, callback) {
  this.$element.on(event, callback)
}

/**
 * Hide button element
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.hide = function() {
  this.$element.hide()
}

/**
 * Show button element
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.show = function() {
  this.$element.show()
}

/**
 * Toggle between hidden and visible
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.toggle = function() {
  this.$element.toggle()
}

/**
 * Disable button
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.disable = function() {
  this.$element.attr('disabled', 'disabled')
}

/**
 * Enable button
 * @memberof! module:api/Button#
 * @api
 */
Button.prototype.enable = function() {
  this.$element.removeAttr('disabled')
}
